import { PageHeader } from '@folio/components';
import { useTranslation } from 'react-i18next';
import { IntermediaryGeneralModule } from '../IntermediaryGeneralModule/IntermediaryGeneralModule';
import { IntermediaryTabsModule } from '../IntermediaryTabsModule/IntermediaryTabsModule';
import { Stack } from '@folio/components/ui/flex';

export function IntermediaryBrokerageFirmListModule() {
  const { t } = useTranslation();

  return (
    <Stack>
      <PageHeader title={t('sidebar.intermediary.brokerageFirms')} />
      <IntermediaryGeneralModule />
      <IntermediaryTabsModule />
    </Stack>
  );
}
